import React from 'react';
import { useSelector } from 'react-redux';
import { permissionCodeSelector } from 'src/selector/user';

const Wrapper = ({ actionCode, children }) => {
  const { permissionCodes } = useSelector(permissionCodeSelector);
  if (!permissionCodes.includes(actionCode)) {
    return null;
  }
  return <>{children}</>;
};

export default Wrapper;
